import { render, staticRenderFns } from "./Crews.vue?vue&type=template&id=af3355ce&scoped=true"
import script from "./Crews.vue?vue&type=script&setup=true&lang=ts"
export * from "./Crews.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Crews.vue?vue&type=style&index=0&id=af3355ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3355ce",
  null
  
)

export default component.exports